import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'
import './component.scss'

const app = Application.start()

app.register(
  'area-modal',
  class extends Controller {
    static targets = ['modal', 'title']
    static values = { buttonLabel: String }

    connect() {
      // 初期スクロール位置を保存
      this.scrollPosition = 0
    }

    // 地域指定でモーダルを開く
    openWithRegion(event) {
      const regionId = event.currentTarget.dataset.regionId

      // すべての都道府県選択オプションを非表示にする
      const prefectureSelectOptions = this.modalTarget.querySelectorAll('.area-modal__prefecture-select-options')
      prefectureSelectOptions.forEach(option => {
        option.classList.remove('area-modal__prefecture-select-options--active')
      })

      // 対象の region-id を持つ option を表示
      const target = this.modalTarget.querySelector(`.area-modal__prefecture-select-options[data-region-id="${regionId}"]`)
      if (target) {
        target.classList.add('area-modal__prefecture-select-options--active')
      }

      // モーダルを開く
      this.open(event)
    }

    // モーダルを開く
    open(event) {
      // スクロール位置を保存
      this.scrollPosition = window.pageYOffset

      // bodyのスクロールを無効化
      document.body.style.overflow = 'hidden'

      // モーダル要素を表示
      const modal = this.modalTarget
      const overlay = modal.querySelector('.js-area-modal-overlay')
      const content = modal.querySelector('.js-area-modal-content')

      if (modal && overlay && content) {
        modal.classList.add('area-modal--active')
        overlay.classList.add('area-modal__overlay--active')
        content.classList.add('area-modal__content--active')
      }
    }

    // モーダルを閉じる
    close() {
      const modal = this.modalTarget
      const overlay = modal.querySelector('.js-area-modal-overlay')
      const content = modal.querySelector('.js-area-modal-content')

      if (overlay && content) {
        overlay.classList.remove('area-modal__overlay--active')
        content.classList.remove('area-modal__content--active')

        // アニメーション終了後にモーダルを非表示
        setTimeout(() => {
          if (modal) {
            modal.classList.remove('area-modal--active')
          }

          // bodyのスクロールを復元
          document.body.style.overflow = ''
          window.scrollTo(0, this.scrollPosition)
        }, 300)
      }
    }
  }
)
